import { render, staticRenderFns } from "./DepartmentDropDownSelector.vue?vue&type=template&id=2815a013&scoped=true&"
import script from "./DepartmentDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentDropDownSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentDropDownSelector.vue?vue&type=style&index=0&id=2815a013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815a013",
  null
  
)

export default component.exports